import React from "react";
import './infoForm.scss'
import Input from "../input/input";
import Constants from "../../../constants";
import { Navigate } from "react-router-dom";
let self;
export class InfoForm extends React.Component<any, any> {
    infoForm = { name: '', dob: '', phone: '', emailId: '', skypeId: '', linkedInUrl: '', gitHubUrl: '', facebookUrl: '', profileUrl: '', resumeLink: '', myInfo: '', typicalHeading: [] };
    constructor(props: any) {
        super(props);
        self = this;
        this.state = { infoForm: this.infoForm, isFormSubmitted: false, noOfTypicalHeadingOption: 0, typicalHeading: {}, radioData: '' }
        this.send = this.send.bind(this);
    }

    infoFormList = [
        {
            placeHolder: 'Enter Your Name',
            type: 'text',
            minLength: '1',
            maxLength: '50',
            name: 'name',
            defaultValue: ''
        },
        {
            placeHolder: 'Enter Your DOB',
            type: 'date',
            minLength: '1',
            maxLength: '50',
            name: 'dob',
            defaultValue: ''
        },
        {
            placeHolder: 'Enter Your Phone No',
            type: 'tel',
            minLength: '10',
            maxLength: '10',
            name: 'phone',
            defaultValue: ''
        },
        {
            placeHolder: 'Enter Your Email',
            type: 'text',
            minLength: '1',
            maxLength: '50',
            name: 'emailId',
            defaultValue: ''
        },
        {
            placeHolder: 'Enter Your Skype Id',
            type: 'text',
            minLength: '1',
            maxLength: '50',
            name: 'skypeId',
            defaultValue: ''
        },
        {
            placeHolder: 'Enter Your Linkdin URL',
            type: 'text',
            minLength: '1',
            maxLength: '200',
            name: 'linkedInUrl',
            defaultValue: ''
        },
        {
            placeHolder: 'Enter Your GitHub URL',
            type: 'text',
            minLength: '1',
            maxLength: '200',
            name: 'gitHubUrl',
            defaultValue: ''
        },
        {
            placeHolder: 'Enter Your Facebook URL',
            type: 'text',
            minLength: '1',
            maxLength: '200',
            name: 'facebookUrl',
            defaultValue: ''
        },
        {
            placeHolder: 'Enter Your profile Image URL',
            type: 'text',
            minLength: '1',
            maxLength: '200',
            name: 'profileUrl',
            defaultValue: ''
        },
        {
            placeHolder: 'Enter Your Resume URL',
            type: 'text',
            minLength: '1',
            maxLength: '200',
            name: 'resumeLink',
            defaultValue: ''
        },
        {
            placeHolder: 'Enter About yourself.',
            type: 'text',
            minLength: '1',
            maxLength: '500',
            name: 'myInfo',
            defaultValue: ''
        }
    ]
    componentDidMount() {
        let previousData:any =  sessionStorage.getItem('portfolioForm');
          const data = JSON.parse(previousData);
        //   console.log(data)
          if(data) {
        // console.log(data)
          }
      }
    send(event) {
        event.preventDefault();
        self.setState({ isFormSubmitted: true })
        self.setState((prevState) => ({
            infoForm: { ...prevState.infoForm, typicalHeading: Object.values(self.state.typicalHeading) }
        }))
        const data: any = sessionStorage.getItem('portfolioForm')
        const previousData = JSON.parse(data);
        sessionStorage.setItem('portfolioForm', JSON.stringify({ ...previousData, ...self.state.infoForm, typicalHeading: Object.values(self.state.typicalHeading) }))
        // console.log(self.state)
    }
    onInputChange(data: any, field: any) {
        self.setState((prevState) => ({
            infoForm: { ...prevState.infoForm, [field]: data }
        }))
    }
    onValueChanges(data: any, field: any) {
        self.setState({ noOfTypicalHeadingOption: data });
    }
    onTypicalHeadingChanges(data: any, field: any) {
        self.setState((prevState) => ({
            typicalHeading: { ...prevState.typicalHeading, [field]: data }
        }))
    }

    handleRadioChange(event:any) {
        // console.log(event.target.value)
        self.setState({radioData: event.target.value})
        sessionStorage.setItem('radioData', event.target.value );
    }

    render(): React.ReactNode {
        return (
            <>
                {(!this.state.isFormSubmitted) &&
                    <div className="info-form__wrapper">
                        <h4>Enter your details</h4>
                        <form onSubmit={this.send}>
                            {
                                this.infoFormList.map((infoForm: any, index: number) => {
                                    return (
                                        <Input placeHolder={infoForm.placeHolder} type={infoForm.type} key={index} value={infoForm.defaultValue} maxLength={infoForm.maxLength} minLength={infoForm.minLength} name={infoForm.name} onInputChange={this.onInputChange}></Input>
                                    )
                                })
                            }
                            <Input placeHolder='How many typicalHeading you nead' type='tel' key={'a'} value="" maxLength="1" minLength="1" onInputChange={this.onValueChanges}></Input>
                            {(this.state.noOfTypicalHeadingOption > 0) &&
                                Array.from({ length: this.state.noOfTypicalHeadingOption }).map((e, i) => {
                                    return <Input placeHolder={`typicalHeading ${i + 1}`} type='text' name={`typicalHeading${i}`} key={i} value="" onInputChange={this.onTypicalHeadingChanges}></Input>
                                })
                            }
                                 <div className=" timeline-list__wrapper">
                        <div className="timeline-list__heading">Are you a ?</div>
                        <div className="form-check timeline-list__check">
                            <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault1" value={Constants.fresher} checked={this.state.radioData === Constants.fresher} onChange={this.handleRadioChange} />
                            <label className="form-check-label timeline-list__label" htmlFor="flexRadioDefault1">
                            {Constants.fresher}
                            </label>
                        </div>
                        <div className="form-check timeline-list__check">
                            <input className="form-check-input" type="radio" name="flexRadioDefault" id="flexRadioDefault2" value={Constants.experianced} checked={this.state.radioData === Constants.experianced}  onChange={this.handleRadioChange} />
                            <label className="form-check-label timeline-list__label" htmlFor="flexRadioDefault2">
                               {Constants.experianced}
                            </label>
                        </div>
                    </div>
                            <button className="form__button app-btn">Next</button>
                        </form>
                    </div>}
                {
                    (this.state.isFormSubmitted) &&
                    <Navigate to="/project-list" replace={true} />
                }
            </>
        )
    }
}

export default InfoForm;